import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { saveActiveViews, WIDGET_VIEWS } from "./widgetsDemoStorage";

const viewMeta = {
  all: {
    title: "All Widgets",
    subtitle: "Weather, Tube and transactions in one dashboard",
    icon: "dashboard_customize"
  },
  weather: {
    title: "Weather",
    subtitle: "Local temperature and forecast",
    icon: "cloud"
  },
  tube: {
    title: "Tube Status",
    subtitle: "Live updates on London Underground lines",
    icon: "train"
  },
  transactions: {
    title: "Account Balance",
    subtitle: "Current balance and recent transactions",
    icon: "account_balance_wallet"
  }
};

const WidgetsDemoSelector = ({ initialActiveViews }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const search = location.search || "";
  const [selected, setSelected] = useState([
    (initialActiveViews && initialActiveViews[0]) || "all"
  ]);

  const selectedView = selected[0];
  const selectedLabel = useMemo(
    () => viewMeta[selectedView]?.title || "All Widgets",
    [selectedView]
  );

  const selectView = (view) => {
    setSelected([view]);
  };

  const handleSave = () => {
    saveActiveViews(selected);
    const targetView = selected[0];
    navigate(`/widgets-demo/${targetView}${search}`);
  };

  return (
    <div
      className="widgets-demo-root relative flex h-auto min-h-screen w-full flex-col bg-[#f8f6f6] overflow-x-hidden text-slate-900"
      style={{ fontFamily: "'Public Sans', sans-serif" }}
    >
        <div className="flex items-center bg-[#f8f6f6] p-4 pb-2 justify-between">
          <div className="text-slate-900 flex size-12 shrink-0 items-center">
            <span className="material-symbols-outlined">tune</span>
          </div>
          <h2 className="text-lg font-bold leading-tight tracking-[-0.015em] flex-1 text-center pr-12">
            Dashboard Preferences
          </h2>
        </div>

        <div className="px-4 pb-2 pt-5">
          <h3 className="tracking-light text-2xl font-bold leading-tight text-left">
            Select active widget pages
          </h3>
          <p className="text-slate-600 text-base font-normal leading-normal pb-3 pt-1">
            Choose which pages are active. The settings cog on pages will always
            bring you back here.
          </p>
        </div>

        <div className="flex flex-col gap-3 p-4">
          {WIDGET_VIEWS.map((view) => (
            <label
              key={view}
              className="group flex items-center gap-4 rounded-xl border border-solid border-slate-200 p-[15px] cursor-pointer hover:border-[#ec5b13]/50 transition-colors"
            >
              <input
                type="radio"
                checked={selectedView === view}
                onChange={() => selectView(view)}
                name="active-widget-page"
                className="h-5 w-5 border-2 border-slate-300 text-[#ec5b13] focus:ring-[#ec5b13]"
              />
              <div className="flex grow flex-col">
                <div className="flex items-center gap-2">
                  <span className="material-symbols-outlined text-[#ec5b13] text-xl">
                    {viewMeta[view].icon}
                  </span>
                  <p className="text-sm font-medium leading-normal">
                    {viewMeta[view].title}
                  </p>
                </div>
                <p className="text-slate-500 text-sm font-normal leading-normal ml-7">
                  {viewMeta[view].subtitle}
                </p>
              </div>
            </label>
          ))}
        </div>

        <div className="flex px-4">
          <button
            type="button"
            onClick={handleSave}
            className="flex min-w-[84px] max-w-full cursor-pointer items-center justify-center overflow-hidden rounded-xl h-14 px-5 flex-1 bg-[#ec5b13] text-white text-base font-bold leading-normal tracking-[0.015em] shadow-lg hover:brightness-110 active:scale-95 transition-all"
          >
            <span className="truncate">Save Preferences</span>
          </button>
        </div>
    </div>
  );
};

export default WidgetsDemoSelector;
